import { Typography, type TypographyProps } from "@mui/material";
import type { FC } from "react";

export const SnackbarHeader: FC<TypographyProps> = ({ children }) => (
	<Typography variant="body1" fontSize="40px" lineHeight="48px" fontWeight={900} marginBottom={0}>
		{children}
	</Typography>
);
